






import { Auth } from 'aws-amplify'

const roleMappings = {
  KaiAdmins: 'Kai Admin',
  KaiEditors: 'Kai Editor',
  ClientAdmins: 'Client Admin',
  TeamAdmins: 'Team Admin',
  Coaches: 'Coach',
  TeamMembers: 'Team Member'
}

const roleDisplayName = role => {
  return roleMappings[role] ?? 'Team Member'
}

export default {
  data: function() {
    return {
      roles: []
    }
  },
  mounted() {
    Auth.currentSession()
      .then(session => session.getAccessToken().decodePayload())
      .then(payload => {
        if (!payload?.['cognito:groups']) {
          payload['cognito:groups'] = ['TeamMembers']
        } else {
          payload['cognito:groups'].push('TeamMembers')
        }
        payload?.['cognito:groups'].map(roleDisplayName)
      })
      .then(roles => (this.roles = roles))
  }
}
